<div class="wrap" [ngClass]="{'open':isEnter}">
  <div class="title fontSize18 lineHeight34">你的课程中心</div>
  <component-solid-card [assetsRoute]="assetsRoute"  [cardList]="courseList" (itemClick)="handleItemClick($event)" >
  </component-solid-card>
</div>
<div id="message-box" [ngClass]="{open:messageBoxOpen,fontSize14:true}">{{ tipMessage }}</div>



// WEBPACK FOOTER //
// ./src/app/course-select/course-select.component.html